export type CompactRecord<T extends object> = {
  [K in keyof T]: T[K] extends undefined ? never : T[K];
};

export function compactOptions<T extends object>(src: T): CompactRecord<T> {
  const dst: Record<string, unknown> = {};
  Object.keys(src).forEach((k) => {
    const val = (src as Record<string, unknown>)[k];
    if (val !== undefined) dst[k] = val;
  });
  return dst as CompactRecord<T>;
}

export function mergeOptions<T extends object>(
  nextOptions: T | null | undefined,
  prevOptions: T | null | undefined
): [mergedOptions: T | null, diffOptions: T | null | undefined] {
  if (nextOptions === null) return [null, null];
  if (nextOptions == null) return [prevOptions || null, undefined];
  if (prevOptions == null) return [nextOptions, nextOptions];

  const mergedOptions = { ...prevOptions };
  let diffOptions: T | undefined;
  (Object.keys(nextOptions) as (keyof T)[]).forEach((k) => {
    const nextValue = nextOptions[k];
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (nextValue !== undefined) {
      mergedOptions[k] = nextValue;
    }
    if (prevOptions[k] !== nextValue) {
      diffOptions ||= {} as T;
      diffOptions[k] = nextValue;
    }
  });
  return [mergedOptions, diffOptions];
}
